import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M15 8h-6h1a3 3 0 0 1 0 6h-1l3 3","key":"svg-1"}],["path",{"d":"M9 11h6","key":"svg-2"}]]

const IconCoinRupee = createReactComponent('outline', 'coin-rupee', 'CoinRupee', __iconNode);

export default IconCoinRupee;